@if (
  {
    isEditStayDrawerVisible: (isEditStaysDrawerVisible$ | async),
    stayToEdit: (stayToEdit$ | async),
  };
  as data
) {
  @if (data.isEditStayDrawerVisible) {
    <wilson-edit-stays-drawer-view
      [isUserFieldReadOnly]="true"
      [showMask]="true"
      [sector]="sector$ | async"
      [disableButtons]="isOperationOnGoingSignal()"
      [isSaving]="isOperationOnGoingSignal()"
      [stayToEdit]="data.stayToEdit"
      (closeDrawer)="closeDrawer()"
      (failedToFillForm)="handleFailedToFillForm()"
      (confirm)="confirm($event)"
      (confirmAndCreateReimbursement)="confirmAndCreateReimbursement($event)"
      (cancelStayAndCreatePdf)="cancelStayAndCreatePdf($event)"
      (delete)="deleteStay()"
      (handleInvoice)="staysAttachmentsHelperService.handleInvoice($event)"
      (handleAttachments)="
        staysAttachmentsHelperService.handleAttachments($event)
      "
    ></wilson-edit-stays-drawer-view>
  }
}
